<template>
  <div
    class="container max-w-md p-6 mx-auto overflow-hidden font-mono text-teal-100 bg-center bg-no-repeat bg-cover shadow-2xl rounded-credential-card"
    :style="`background-image: url(${require('../assets/fondo.png')})`"
  >
    <span class="text-4xl font-bold tracking-widest">{{ nroCredencial }}</span>

    <div class="mt-2">
      <span class="text-2xl font-semibold tracking-wider uppercase">
        {{ nombreCompleto }}
      </span>
    </div>

    <div class="pb-2 mt-4 text-lg tracking-widest border-b border-teal-100">
      <p>Nº {{ contrato | nroAfiliado(integrante) }}</p>
      <p class="mt-1">{{ documentoCompleto }}</p>
    </div>

    <div class="grid grid-cols-4 grid-rows-3 row-gap-1 mt-4 font-bold tracking-wide text-md">
      <span>Emitida</span>
      <div class="col-span-3 text-right">{{ fechaEmision }}</div>

      <span>Vencimiento</span>
      <div class="col-span-3 text-right">{{ fechaVencimiento }}</div>

      <span>Validada</span>
      <div class="col-span-3 text-right">{{ fechaValidacion }}</div>
    </div>

    <div class="mt-6">
      <span class="text-2xl font-black tracking-widest uppercase">{{ condicion }}</span>
    </div>

    <div class="flex items-center justify-between mt-4">
      <img class="w-6/13" :src="require('../assets/logo-colegio.png')" />
      <img class="w-6/13" :src="require('../assets/logo-caja.png')" />
    </div>
  </div>
</template>

<script>
import credentialProps from '@/mixins/credentialProps'

export default {
  props: {
    credencial: { type: Object, required: true },
  },

  mixins: [credentialProps],
}
</script>

<style>
.rounded-credential-card {
  border-radius: 2.25rem;
}

.w-6\/13 {
  width: 46.1538%;
}
</style>
